/** @format */

import React from 'react';
import Vend from '../../components/vend';

export default function PremiumPg(props) {
  return <Vend {...props}/>;
}
